import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { startAutoUpdate, tookUpdate } from './utils/autoUpdate';
import toast from 'react-hot-toast';

// Новая версия доезжает до людей сама: у пресса и на складе объяснять
// Ctrl+Shift+R некому и некогда, а до тех пор работают по старому экрану.
startAutoUpdate();
if (tookUpdate()) {
  setTimeout(() => toast.success('Программа обновилась', { duration: 4000 }), 900);
}

// PWA — только для клиентского экрана. Телефон предлагает «добавить на
// главный экран» лишь сайту с service worker'ом, но заводским терминалам он
// не нужен вовсе: там браузер открыт круглые сутки на одной странице, а
// лишний слой между ним и dev-сервером CRA — это ещё одно место, где
// обновление может застрять.
// Регистр пути не проверяем: маршрутизатор сопоставляет адреса без учёта
// регистра, и «/TRACK/K7M2QX» открывает ту же страницу. Со строгой проверкой
// такой адрес молча оставался без worker'а — а без него телефон не предлагает
// установку вовсе: экран открывается, «Установить» не появляется нигде, и
// понять почему невозможно.
if ('serviceWorker' in navigator
    && (window.location.pathname.toLowerCase().startsWith('/track')
        || /^\/ai(\/|$)/i.test(window.location.pathname))) {
  window.addEventListener('load', () => {
    // Ошибку не глотаем: молчащая регистрация — это ровно тот случай, когда
    // потом полдня гадаешь, почему установки нет.
    navigator.serviceWorker.register('/sw.js')
      .catch(e => console.error('service worker не зарегистрирован:', e));
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);
